import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LocationSelectService } from '../location-select.service';
import { Locations } from '../location.model';

@Component({
  selector: 'csi-region-select',
  templateUrl: './region-select.component.html',
  styleUrls: ['./region-select.component.css']
})
export class RegionSelectComponent implements OnChanges {
  @Input() regionControl: FormControl;
  @Input() country: string;

  @Output() regionsLoaded = new EventEmitter<Locations>();

  public regions$: Observable<Locations>;

  constructor(private locationSelectService: LocationSelectService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.country) {
      if (!this.country) {
        this.regionsLoaded.emit({ list: [], label: null });
        return;
      }

      this.regions$ = this.locationSelectService
        .getRegionsForCountry(this.country)
        .pipe(tap(regions => this.regionsLoaded.emit(regions)));
    }
  }
}
